import './TechnicalQuestion.css';

export default function TechnicalQuestion({ question, onClose }) {
  return (
    <div className="widget-card">
      <div className="widget-card-header">
        <span className="widget-card-title">Questions</span>
        <button className="widget-close-btn" onClick={onClose}>&times;</button>
      </div>
      <div className="question-body">
        <div className="question-pill">Q1</div>
        <p className="question-text">{question}</p>
      </div>
    </div>
  );
}
